import { useEffect, useState } from "react";
import { GoogleFormComponent, GoogleFormStatus, useGoogleForm } from "@components/organisms/GoogleForm";
import { DefaultTemplate } from "@components/templates/default";

export function GroupEvents() {
    enum Status {
        GoogleForm,
        SaysGoodbye,
    };

    const [status, setStatus] = useState(Status.GoogleForm);
    const { loading, status: formStatus } = useGoogleForm()
    // logger.debug('status', formStatus)

    useEffect(() => {
        if (formStatus == GoogleFormStatus.end) {
            setStatus(Status.SaysGoodbye);
        }
    }, [formStatus]);

    const GoodByeAnouncement = () => <div className="prose p-8">
        ¡Terminado! Estaremos en contacto para agendar el evento
    </div>;

    return <DefaultTemplate>
        <div className="flex-1 flex items-center justify-center">
            <div className='h-full w-full flex'>
                {{
                    [Status.GoogleForm]: <GoogleFormComponent
                        loading={loading}
                        googleFormID="1FAIpQLSc1RzAtP7BLg_UWxLlPxRy67CcB8ZtCUlroAwKzEdGi5X9EmQ"
                        className="w-full h-full"
                        status={formStatus}
                    />,
                    [Status.SaysGoodbye]: <GoodByeAnouncement />,
                }[status]}
            </div>
        </div>
    </DefaultTemplate>;
}
